import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export class ContextButton {

  identifier: string;
  displayText: string;
  disabled: boolean;
  returnObj: any;

  constructor(identifier: string, displayText: string, disabled: boolean, returnObj: any) {
    this.identifier = identifier;
    this.displayText = displayText;
    this.disabled = disabled;
    this.returnObj = returnObj;
  }

  setEnabled(disabled: boolean) {
    this.disabled = disabled;
  }

}

export class ContextEvent {

  eventType: string;
  eventIdentifier: string;
  eventPayload: any;

  constructor(eventType: string, eventIdentifier: string, eventPayload) {
    this.eventType = eventType;
    this.eventIdentifier = eventIdentifier;
    this.eventPayload = eventPayload;
  }

}

@Component({
  selector: 'app-general-context',
  templateUrl: './general-context.component.html',
  styleUrls: ['./general-context.component.css']
})
export class GeneralContextComponent implements OnInit {

  @Input() positionX = 0;
  @Input() positionY = 0;
  @Input() actionButtons: ContextButton[] = []

  @Output() actionEvent = new EventEmitter<ContextEvent>();

  constructor() { }

  ngOnInit() {
  }

  emitClickEvent(contextButton: ContextButton) {
    let event = new ContextEvent('click', contextButton.identifier, contextButton.returnObj);
    this.actionEvent.emit(event);
  }

  emitCloseEvent() {
    let event = new ContextEvent('close', null, null);
    this.actionEvent.emit(event);
  }


}
